import MobileDetect from 'mobile-detect'
import { useRef } from 'react'

interface DetectedDevice {
  hasTouch: boolean
  isDesktop: boolean
  isMobile: boolean
  isPhone: boolean
  isTablet: boolean
  OS: string
}

let detectedDevice: DetectedDevice = {
  hasTouch: false,
  isDesktop: false,
  isMobile: false,
  isPhone: false,
  isTablet: false,
  OS: '',
}
let userAgent = ''

const useDeviceDetect = () => {
  const ref = useRef<DetectedDevice>({ ...detectedDevice } as const)

  if (userAgent !== navigator.userAgent) {
    userAgent = navigator.userAgent
    const mobileDetect = new MobileDetect(userAgent)
    const isMobile = !!mobileDetect.mobile() || /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent)
    const isTablet = !!mobileDetect.tablet() || /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent)
    const isPhone = !!mobileDetect.phone() || (isMobile && !isTablet)
    const isDesktop = !isPhone && !isTablet && !isMobile

    detectedDevice = {
      hasTouch:
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        // @ts-expect-error msMaxTouchPoints is a non-standard property
        navigator.msMaxTouchPoints > 0 ||
        window.matchMedia?.('(pointer:coarse)')?.media === '(pointer:coarse)' ||
        !!mobileDetect.mobile(),
      isDesktop,
      isMobile,
      isPhone,
      isTablet,
      OS: mobileDetect.os(),
    }
    ref.current = { ...detectedDevice } as const
  }

  return ref.current
}

export default useDeviceDetect
